import {Injectable} from '@angular/core';
import {FeatureToggle} from './feature-toggle';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ToggleService} from './toggle.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleService {

  constructor(private toggleService: ToggleService) { }

  isFeatureToggleActive(featureToggle: FeatureToggle): Observable<boolean> {
    return this.toggleService.getToggle(featureToggle).pipe(map((data) => data.active));
  }
}
